import apiFetch from '@wordpress/api-fetch';

/**
 * Handle NSC Member Code Confirmation.
 */
const initNscVerification = () => {
	const forms = document.querySelectorAll<HTMLFormElement>( '.nsc-member-pricing-form' );

	forms.forEach( ( form ) => {
		const button = form.querySelector<HTMLButtonElement>( '.confirm_nsc_member_code' );
		const input = form.querySelector<HTMLInputElement>( '.nsc_member_code' );
		const container = form.closest( '.crsc-nsc-verification-section' );
		const messageContainer = container ? container.querySelector( '.form-messages' ) : null;

		if ( ! button || ! input || ! form || ! messageContainer ) {
			return;
		}

		form.addEventListener( 'submit', ( e ) => {
			e.preventDefault();

			const code = input.value.trim();
			const nonceInput = form.querySelector<HTMLInputElement>( 'input[name="nsc_nonce"]' );
			const nonce = nonceInput ? nonceInput.value : '';
			const nscProductIdInput = form.querySelector<HTMLInputElement>( 'input[name="nsc_product_id"]' );
			const nscProductId = nscProductIdInput ? nscProductIdInput.value : '';


			if ( ! code ) {
				if ( messageContainer ) {
					messageContainer.innerHTML = 'Please enter a member number.';
					messageContainer.classList.remove('success', 'info');
					messageContainer.classList.add( 'error', 'is-visible' );
				}
				return;
			}

			button.disabled = true;
			if ( messageContainer ) {
				messageContainer.innerHTML = 'Verifying membership number...';
				messageContainer.classList.remove('success', 'error');
				messageContainer.classList.add( 'info', 'is-visible' );
			}

			apiFetch( {
				path: 'crsc-dbs/v1/confirm-nsc_member_code',
				method: 'POST',
				data: { 
					code: code,
					nsc_nonce: nonce,
					product_id: nscProductId,
				},
			} )
				.then( ( response: any ) => {
					if ( response.success ) {
						if ( messageContainer ) {
							messageContainer.innerHTML = 'Member number confirmed! Reloading page...';
							messageContainer.classList.remove('error', 'info');
							messageContainer.classList.add( 'success', 'is-visible' );
						}
						// Reload page to apply prices
						let new_location_with_params = window.location.href;
						// Add a parameter to the URL to force a page refresh
						let current_params = new URLSearchParams( window.location.search );
						hashString( code ).then( ( hash ) => {
							sessionStorage.setItem( 'crsc_no_cache', hash );
							current_params.set( 'crsc_no_cache', hash );
							new_location_with_params = `${window.location.origin}${window.location.pathname}?${current_params.toString()}`;
							window.location.href = new_location_with_params;
						});
					} else {
						throw new Error( response.message || 'Invalid member number. Please try again.' );
					}
				} )
				.catch( ( error ) => {
					if ( messageContainer ) {
						messageContainer.innerHTML = error.message;
						messageContainer.classList.remove('success', 'info');
						messageContainer.classList.add( 'error', 'is-visible' );
					}
					button.disabled = false;
				} );
		} );
	} );
};

/**
 * Generates a SHA-256 hash for a given string and returns the result as a hexadecimal string.
 *
 * @param {string} string - The input string to hash.
 * @return {Promise<string>} A promise that resolves to the hexadecimal representation of the hash.
 */
async function hashString(string: string) {
	// 1. Encode string to a Uint8Array
	const encoder = new TextEncoder();
	const data = encoder.encode(string);

	// 2. Hash the data using SHA-256
	const hashBuffer = await crypto.subtle.digest('SHA-256', data);

	// 3. Convert buffer to byte array
	const hashArray = Array.from(new Uint8Array(hashBuffer));

	// 4. Convert bytes to a hex string
	return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

// Initialize on DOM load
document.addEventListener( 'DOMContentLoaded', initNscVerification );

const initialUrl = window.location.href;
// Re-add the listeners for checking the NSC member price when Facetwp refreshes results.
document.addEventListener( 'facetwp-loaded', () => {
	if ( window.location.href !== initialUrl ) {
		setTimeout( () => {
			initNscVerification();
		}, 1000 );
	}
} );
